import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Downloader {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  async downloadUrl(url: string, filename?: string, target?: string) {
    const a = this.document.createElement('a');
    if (filename) {
      a.download = filename;
    }
    if (target) {
      a.target = target;
    }
    a.href = url;
    document.body.appendChild(a);
    a.click();
    a.remove();
    await new Promise(resolve =>
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
        resolve(undefined);
      }, 0),
    );
  }

  async downloadBlob(blob: Blob, filename: string) {
    const a = this.document.createElement('a');
    a.download = filename;
    a.href = URL.createObjectURL(blob);
    document.body.appendChild(a);
    a.click();
    a.remove();
    await new Promise(resolve =>
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
        resolve(undefined);
      }, 0),
    );
  }
}
